import { useMutation } from "react-query";
import { sendSingleAttributeData } from "../lib/attribute-data";

export const useAttributeUpdate = () => {
    return useMutation(({ codingWipKey, taskKey, sourcePage, payload }) => sendSingleAttributeData(codingWipKey, taskKey, sourcePage, payload));
};
